import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const TeamPage = lazy(() => import('../../view/pages/TeamPage'));

export const teamRoutes: RouteObject = {
  path: pagePath.team,
  children: [
    {
      index: true,
      element: <TeamPage />,
    },
  ],
};
